import axios from 'axios';
import config from '@/config';

function screenLogger() {
  let logMessages = [];

  function addLog(message) {
    const timestamp = new Date().toISOString();
    const logMessage = `${timestamp} - ${message}`;
    logMessages.push(logMessage);
  }

  async function sendLogs(additionalFields = {}) {
    if (logMessages.length > 0) {
      const url = config.loggerUrl;
      const user = localStorage.getItem('user-username');
      if (url) {
        await axios.post(url, {
          user: user,
          logs: logMessages,
          source: 'CMS',
          ...additionalFields,
        });
      }
      logMessages = [];
    }
  }

  return {
    addLog,
    sendLogs,
  };
}

export const logger = screenLogger();
